import _styled from "@emotion/styled/base";
const _excluded = ["children"],
  _excluded2 = ["anchorOrigin", "transformOrigin", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useState, useRef, cloneElement, createContext, useContext } from 'react';
import { Menu, MenuItem, MenuSeparator } from '../Menu';
import { jsx as ___EmotionJSX } from "@emotion/react";
const DropdownContext = /*#__PURE__*/createContext({
  triggerRef: null,
  open: false,
  onOpenToggle: () => {}
});
const Trigger = /*#__PURE__*/_styled("div", {
  target: "en3x73a0",
  label: "Trigger"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function DropdownProvider({
  children
}) {
  const triggerRef = useRef(null);
  const [open, setOpen] = useState(false);
  function onOpenToggle() {
    setOpen(!open);
  }
  return ___EmotionJSX(DropdownContext.Provider, {
    value: {
      triggerRef,
      open,
      onOpenToggle
    }
  }, children);
}
export function useDropdownContext() {
  const context = useContext(DropdownContext);
  if (!context) {
    throw new Error('useDropdownContext must be used within a DropdownProvider');
  }
  return context;
}
function Dropdown({
  children
}) {
  return ___EmotionJSX(DropdownProvider, null, React.Children.map(children, child => {
    if (child.type.name === 'DropdownTrigger' || child.type.name === 'DropdownMenu') {
      return /*#__PURE__*/cloneElement(child);
    }
    return null;
  }));
}
function DropdownTrigger(_ref) {
  let {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    triggerRef,
    onOpenToggle
  } = useDropdownContext();
  return ___EmotionJSX(Trigger, _extends({
    ref: triggerRef,
    onClick: onOpenToggle
  }, props, {
    "data-slot": "trigger"
  }), children);
}
DropdownTrigger.displayName = 'DropdownTrigger';
function DropdownMenu(_ref2) {
  let {
      anchorOrigin,
      transformOrigin,
      children
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
    triggerRef,
    open,
    onOpenToggle
  } = useDropdownContext();
  return ___EmotionJSX(Menu, _extends({
    anchorEl: triggerRef.current,
    anchorOrigin: anchorOrigin,
    transformOrigin: transformOrigin,
    open: open,
    onClose: onOpenToggle
  }, props), children);
}
DropdownMenu.displayName = 'DropdownMenu';
export { Dropdown, DropdownTrigger, DropdownMenu, MenuItem as DropdownMenuItem, MenuSeparator as DropdownMenuSeparator };